import type { AppDispatch } from '../redux-store';
import { signOut } from '../user/user.async-thunks';

let signOutInFlight: ReturnType<AppDispatch> | null = null;

/**
 * Ensures concurrent session-expiry handlers share a single sign-out request.
 */
export function triggerSignOut(dispatch: AppDispatch): ReturnType<AppDispatch> {
  if (!signOutInFlight) {
    signOutInFlight = dispatch(signOut());
    signOutInFlight.finally(() => {
      signOutInFlight = null;
    });
  }

  return signOutInFlight;
}
